import { SORT_NAME_ASC, SORT_NAME_DESC, SORT_MOST_POPULAR, SORT_NEWEST } from '@alycecom/ui';

let BASIC_SORTING_ITEMS = [SORT_NAME_ASC, SORT_NAME_DESC, SORT_MOST_POPULAR];

export const SORT_RECOMMENDED_ID = 6;

export const SORT_RECOMMENDED = {
  id: SORT_RECOMMENDED_ID,
  label: 'Recommended for you',
  value: {
    column: 'recommendations',
    order: 'desc',
  },
};

export const SORT_PRODUCT_TYPE_ID = 7;

export const SORT_PRODUCT_TYPE = {
  id: SORT_PRODUCT_TYPE_ID,
  label: 'Product type',
  value: {
    column: 'product_type',
    order: 'asc',
  },
};

export interface ISortingItemsParams {
  isDeclaredDataEnabled: boolean;
  hasCustomMarketplace: boolean;
  isWhiteLabeling: boolean;
}

export const getSortingItems = ({
  isDeclaredDataEnabled,
  hasCustomMarketplace,
  isWhiteLabeling,
}: ISortingItemsParams): typeof BASIC_SORTING_ITEMS => {
  if (!isWhiteLabeling) {
    BASIC_SORTING_ITEMS = [...BASIC_SORTING_ITEMS, SORT_NEWEST];
  }
  const SORTING_ITEMS_WITH_RECOMMENDED = [...BASIC_SORTING_ITEMS, SORT_RECOMMENDED];
  const SORTING_ITEMS_WITH_CUSTOM_MARKETPLACE = [...BASIC_SORTING_ITEMS, SORT_PRODUCT_TYPE];

  if (hasCustomMarketplace) {
    return SORTING_ITEMS_WITH_CUSTOM_MARKETPLACE;
  }

  if (isDeclaredDataEnabled) {
    return SORTING_ITEMS_WITH_RECOMMENDED;
  }
  return BASIC_SORTING_ITEMS;
};
